import { Dialog } from "@headlessui/react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Logout = ({ isOpen, onClose }) => {
  const handleLogout = () => {
    localStorage.removeItem("loggedIn");
    toast.success("Logged out successfully!");
    onClose();
    setTimeout(() => {
        window.location.href = "/login";
      }, 1000);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      className="fixed inset-0 flex items-center justify-center bg-[rgb(40_40_40_/_50%)]"
    >
      <div className="bg-[#282828] p-10 rounded-lg shadow-[0_3px_5px_#000000] ">
        <div className="text-lg text-center font-medium text-white">Logout</div>
        <p className="mt-6 text-white text-center">
          Are you sure you want to Logout?
        </p>

        {/* Buttons */}
        <div className="mt-7 flex justify-around space-x-2">
          <div className="px-4 py-2 bg-[#FC0005] text-white rounded-md flex gap-[5px] w-full items-center justify-center cursor-pointer" onClick={handleLogout}>
            <button>Yes</button>
          </div>
          <div className="px-4 py-2 bg-[#2D3EBC] rounded-md flex gap-[5px] w-full items-center justify-center cursor-pointer" onClick={onClose}>
            <button  className="text-white">
              No
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};
export default Logout;
